import React from "react"
import truncate from "lodash.truncate"

import styles from "../styles/post-block.module.scss"
import { Link, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

import wavePattern from "../images/wave-pattern.svg"

const PostBlock = ({
  slug,
  title,
  category,
  excerpt,
  avatar,
  avatarSlug,
  author,
  // date,
  featuredImage,
}) => {
  const data = useStaticQuery(graphql`
    query {
      jamieProfile: file(relativePath: { eq: "jdavidson.jpg" }) {
        childImageSharp {
          fixed(width: 34, height: 34) {
            ...GatsbyImageSharpFixed_withWebp_noBase64
          }
        }
      }

      kurtProfile: file(relativePath: { eq: "kurtbirk.jpg" }) {
        childImageSharp {
          fixed(width: 34, height: 34) {
            ...GatsbyImageSharpFixed_withWebp_noBase64
          }
        }
      }
    }
  `)

  return (
    <Link to={`/blog/${slug}`} className={styles.mainContainer}>
      <div
        className={styles.headerImage}
        style={{
          backgroundImage: featuredImage ? null : `url('${wavePattern}')`,
          backgroundPosition: "center",
        }}
      >
        {featuredImage && featuredImage}
      </div>
      <div className={styles.textContainer}>
        <div>
          <div className={styles.textHeader}>
            <div className={styles.category}>{category}</div>
          </div>
          <h3 dangerouslySetInnerHTML={{ __html: title }} />
          <p>
            {truncate(excerpt.replace(/<\/?[^>]+(>|$)/g, ""), {
              length: 157,
              separator: /,? +/,
            })}
          </p>
        </div>

        <div className={styles.postBlockAuthorContainer}>
          <div
            className={styles.avatar}
            // style={{
            //   background: `url("${avatar}") no-repeat center center / cover`,
            // }}
          >
            {avatarSlug === "jdavidson" && (
              <Img
                fixed={data.jamieProfile.childImageSharp.fixed}
                alt="avatar"
                style={{ width: "34px", height: "34px" }}
                imgStyle={{
                  width: "34px",
                  height: "34px",
                }}
              />
            )}

            {avatarSlug === "kurtbirk" && (
              <Img
                fixed={data.kurtProfile.childImageSharp.fixed}
                alt="avatar"
                style={{ width: "34px", height: "34px" }}
                imgStyle={{
                  width: "34px",
                  height: "34px",
                }}
              />
            )}
          </div>
          <h4 className={styles.authorDate}>{author}</h4>
        </div>
      </div>
    </Link>
  )
}

export default PostBlock
